import React from 'react';
import { Box, Text } from '@chakra-ui/react';

/**
 * ResearchTip - Simple text component for research insights
 */
const ResearchTip = ({
  text = "🌟🌟 Getting attendees to speak at the beginning of the meeting increase participation 45%. See research."
}) => {
  return (
    <Box>
      <Text fontSize="12px" color="#000000">
        {text}
      </Text>
    </Box>
  );
};

export default ResearchTip;
